var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.96,
    height: 35.952,
    viewBox: "0 0 29.96 35.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M23.994,4a1.5,1.5,0,0,1,1.48,1.5V38.454A1.5,1.5,0,0,1,24,39.952H7.5a1.5,1.5,0,0,1-1.5-1.5V13.589A4.5,4.5,0,0,1,8.959,9.364C13.333,7.775,23.464,4.09,23.464,4.09A1.518,1.518,0,0,1,23.949,4h.022ZM28.47,16.281l4.767,2.042a4.5,4.5,0,0,1,2.723,4.132v16a1.5,1.5,0,0,1-1.5,1.5H28.214a4.469,4.469,0,0,0,.256-1.5ZM18,29.466a1.5,1.5,0,0,0-.019-3H13.49a1.5,1.5,0,1,0,0,3h4.494Zm0-5.992a1.5,1.5,0,0,0-.019-3H13.49a1.5,1.5,0,0,0,0,3h4.494Zm0-5.992a1.5,1.5,0,0,0-.019-3H13.49a1.5,1.5,0,1,0,0,3h4.494Z",
    transform: "translate(-6 -4)",
    fill: "#df9426",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildIcon);
export default __webpack_public_path__ + "static/media/build_icon.fd394d0862f99547d386a731662eaa9a.svg";
export { ForwardRef as ReactComponent };